<template>
    <div class="work_group">
        <div class="work_group_title">{{ departmentTitle }}</div>
        <div class="work_group_member">
            <WorkStateMemberByCode
                v-for="[key, value] of resultData"
                :key="key"
                :value="value"
                :workCodes="workCodes"/>
            <div v-if="resultData.size == 0">
                <small class="lgray_txt txt_center w_full">{{ $t('reservationwindow.leftpannel.label_noworkers') }}</small>
            </div>
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import WorkStateMemberByCode from './Items/WorkStateMemberByCodeItem.vue'
import moment from '@/util/MPMoment'

export default {
    components: {WorkStateMemberByCode},
    props: {
        departmentID: String,
        value: Array,
        departments: Array,
        employees: Array,
        workCodes: Array
    },
    data() {
        return {
            data: []
        }
    },
    watch: {
        value: {
            depp: true,
            immediate: true,
            handler: function (newValue) {
                if (!newValue) return
                this.initialData(newValue)
            }
        },
    },
    computed: {
        sortCodeMap: function () {
            return new Map(this.workCodes.map(obj => [obj._id, obj.sortNum]))
        },
        filterCodeIds: function () {
            return this.workCodes.filter(obj => obj.isSelected).map(c => c._id)
        },
        departmentTitle: function () {
            return this.departments?.find(d => {
                return d._id == this.departmentID
            })?.title ?? ''
        },
        sortedEmployees: function () {
            return this.employees.filter(e => e.departmentID._id == this.departmentID && !this.value.some(d => d.employee._id == e._id))
        },
        sortedEmployeesMap: function () {
            return new Map(this.sortedEmployees.map(obj => [obj._id, obj.sortNum]))
        },
        resultData: function () {
            let result = this.deepCopyMap(this.data)
            result.forEach((array, key) => {
                let filteredArray = array.filter(item => {
                    let id = item.workCodeID?._id ?? (item.isCustomized ? 'custom' : (item.isBasic ? 'basic' : undefined))
                    return this.filterCodeIds.includes(id)
                })
                if (filteredArray.length == 0) {
                    result.delete(key)
                } else {
                    result.set(key, filteredArray.sort((l, r) => {
                        return (this.sortedEmployeesMap.get(l.employee._id) || 0) - (this.sortedEmployeesMap.get(r.employee._id) || 0)
                    }))
                }
            })
            return result
        }
    },
    methods: {
        initialData(value) {
            let copyValue = deepCopy(value)
            let data = copyValue.sort((l, r) => {
                let sortL = l.workCodeID?._id ? this.sortCodeMap.get(l.workCodeID._id) : null
                let sortR = r.workCodeID?._id ? this.sortCodeMap.get(r.workCodeID._id) : null

                if (sortL != null && sortR != null) {
                    return sortL - sortR
                } else if (sortL != null) {
                    return -1
                } else if (sortR != null) {
                    return 1
                } else {
                    return this.compareDates(l, r)
                }
            })

            let mapData = data.reduce((map, record) => {
                    let key = record.workCodeID?._id || `${moment(record.startedAt).format('HHmm')}${moment(record.endedAt).format('HHmm')}`
                    if (!map.has(key)) {
                        map.set(key, [])
                    }
                    map.get(key).push(record)
                    return map
                }, new Map()
            )

            mapData.set('basic', this.sortedEmployees.map(employee => ({
                isBasic: true,
                employee: {
                    _id: employee._id,
                    title: employee.title
                }
            })));


            this.data = mapData
        },
        compareDates(left, right) {
            let targetData = moment(left.startedAt)
            let checkData = moment(right.startedAt)
            let timeComparison = targetData - checkData
            if (timeComparison != 0) return timeComparison

            return moment(left.endedAt) - moment(right.endedAt)
        },
        deepCopyMap(originalMap) {
            let newMap = new Map()
            originalMap.forEach((value, key) => {
                let copiedArray = value.map(obj => ({...obj}))
                newMap.set(key, copiedArray)
            });
            return newMap
        }
    }
}
</script>